import { useRef, useEffect } from "react";

import { animationsRegistry } from "./animations";
import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import {ITae} from "../../../../models/game/ITae";
import {isMobile} from "react-device-detect";
import {resolveTargetCoords} from "./resolveTargetCoords";

interface TargetAnimationsProps {
    targetData: any;
    tae: ITae;
}

function TargetAnimations({
                              targetData,
                              tae,
                          }: TargetAnimationsProps) {
    const { coords } = useTypedSelector((state) => state.animation);
    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        canvas.style.background = "transparent";

        const rect = canvas.getBoundingClientRect();
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;


        const result = resolveTargetCoords(targetData, coords, canvas, rect, scaleX, scaleY);

        if (!result) {
            return;
        }

        const { x: endX, y: endY } = result;

        const startCoords = coords["played_card_container"];

        const startX = startCoords.x
        const startY = startCoords.y ;

        const startTime = performance.now();

        const factory = animationsRegistry[tae.animation];

        if (!factory) return;


        let animationScale =  tae.scale;
        if(isMobile){
          animationScale = Math.round((animationScale / 2) * 10) / 10;
        }

        const frameFn = factory({
            ctx,
            canvas,
            startX,
            startY,
            endX,
            endY,
            startTime,
            scale:animationScale
        });

        let rafId: number;

        const loop = (now: number) => {
            const shouldContinue = frameFn(now);
            if (shouldContinue) {
                rafId = requestAnimationFrame(loop);
            } else {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
        };

        rafId = requestAnimationFrame(loop);

        return () => {
            cancelAnimationFrame(rafId);
        };
    }, [coords, targetData, tae.animation]);

    return (
        <canvas
            ref={canvasRef}
            width={window.innerWidth}
            height={window.innerHeight}
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 320,
                pointerEvents: "none",
            }}
        />
    );
}

export default TargetAnimations;
